import styled, { keyframes } from "styled-components";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import { useState } from "react";

import { TbLoader2 } from "react-icons/tb";

import useApi from "../../hooks/useApi";
const spin = keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
`;

const IconeContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`
const Titulo = styled.h3`
    color: #000;
    font-size: 16px;
    margin: 0 auto;
`
const SubTitulo = styled.h4`
    color: #707070;
    font-size: 14px;
    margin: 5px auto;
    text-align: center;
`
const LinhaBotoes = styled.div`
    width: 100%;
    height: 40px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    & button{
        width: 48%;
        height: 100%;
        border-radius: 3px;
        border: none;
        cursor: pointer;
        transition: .3s;
        font-weight: bold;
    }
    & button:hover{
        scale: 1.05;
    }
`
const BotaoCancelar = styled.button`
    background-color: #ececec;
`
const BotaoConfirmar = styled.button`
    background-color: #e91b1b;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
`
const EmailDestaque = styled.span`
    color: #e91b1b;
`
const IconeLoad = styled(TbLoader2)`
    width: 25px;
    height: 25px;
    margin: auto;
    animation: ${spin} 1s linear infinite;
`


const ModalDeleteEmail = ({ item, fecharModal, atualizar }) => {
    const api = useApi();


    const [loading, setLoading] = useState(false);

    const submitDelete = async () => {

        setLoading(true);

        try {
            await api.post('/Painel/API/Cipa/DeleteEmail/', {
                id: item.id
            })

            await atualizar();
            fecharModal();

        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="sm" >
                    <IconeContainer>
                        <Titulo>APAGAR E-MAIL</Titulo>
                        <SubTitulo>Tem certeza de que deseja excluir o e-mail {<EmailDestaque> {item.email} </EmailDestaque>} ? Essa ação é irreversível.</SubTitulo>
                    </IconeContainer>
                    <LinhaBotoes>
                        <BotaoCancelar onClick={fecharModal} >CANCELAR</BotaoCancelar>
                        <BotaoConfirmar onClick={submitDelete}>
                            {
                                loading ? <IconeLoad /> : "APAGAR"
                            }</BotaoConfirmar>
                    </LinhaBotoes>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalDeleteEmail;